export const acceptLanguages = ["en-us", "zh-tw", "zh-cn", "vi-vn"];

export const defaultLanguage = "en-us";
